const statisticsApi = {
  dailyTableData: 'CSVPA-China/api/statistics/getBasicGradesStatistics', //日常表现
  GETBASICGRADESSTATISTICSNEW:
    'CSVPA-China/api/statistics/getBasicGradesStatisticsNew', //日常表现
  comprehensiverTableData:
    'CSVPA-China/api/statistics/getComprehensiveStatistics', //全年成绩统计
  GETCOMPREHENSIVESTATISTICSNEW:
    'CSVPA-China/api/statistics/getComprehensiveStatisticsNew', //全年成绩统计
  MidTableData: 'CSVPA-China/api/statistics/getMidTermExamStatistics', //期中成绩统计
  GETMIDTERMEXAMSTATISTICSNEW:
    'CSVPA-China/api/statistics/getMidTermExamStatisticsNew', //期中成绩统计
  FinalTableData: 'CSVPA-China/api/statistics/getFinalTermExamStatistics', //期末成绩统计
  GETFINALTERMEXAMSTATISTICSNEW:
    'CSVPA-China/api/statistics/getFinalTermExamStatisticsNew', //期末成绩统计
  quizTableData: 'CSVPA-China/api//statistics/getQuizGradesStatistics', //小测成绩
  GETQUIZGRADESSTATISTICSNEW:
    'CSVPA-China/api//statistics/getQuizGradesStatisticsNew', //小测成绩
  exportDaily: 'CSVPA-China/api/statistics/exportBasicsGradesStats', //日常表现数据导出
  EXPORTBASICSGRADESSTATSNEW:
    'CSVPA-China/api/statistics/exportBasicsGradesStatsNew', //日常表现数据导出
  exportComprehensiver: 'CSVPA-China/api/statistics/exportComprehensiveStats', //日常表现数据导出
  EXPORTCOMPREHENSIVESTATSNEW:
    'CSVPA-China/api/statistics/exportComprehensiveStatsNew', //日常表现数据导出
  exportMid: 'CSVPA-China/api/statistics/exportMidTermExamStats', //日常表现数据导出
  EXPORTMIDTERMEXAMSTATSNEW:
    'CSVPA-China/api/statistics/exportMidTermExamStatsNew', //日常表现数据导出
  exportFinal: 'CSVPA-China/api/statistics/exportFinalTermExamStats', //日常表现数据导出
  EXPORTFINALTERMEXAMSTATSNEW:
    'CSVPA-China/api/statistics/exportFinalTermExamStatsNew', //日常表现数据导出
  exportQuiz: 'CSVPA-China/api/statistics/exportQuizGradesStats', //日常表现数据导出
  EXPORTQUIZGRADESSTATSNEW:
    'CSVPA-China/api/statistics/exportQuizGradesStatsNew', //日常表现数据导出
  getClassListAll: 'CSVPA-China/api/classes/getClassesList', //日常表现数据导出
  GETCLASSESLISTNEW: 'CSVPA-China/api/classes/getClassesListNew',
  getGradeListAll: 'CSVPA-China/api/classes/getGradeList', //日常表现数据导出
  getCourseByIdClass: 'CSVPA-China/api/course/getListByClassId', //根据班级查询课程
  GETLISTBYCLASSIDNEW: 'CSVPA-China/api/course/getListByClassIdNew', //根据班级查询课程
  getListByGrade: 'CSVPA-China/api/course/getListByGrade', //根据年级查询课程
}

export default statisticsApi
